import React, { useContext } from 'react';
import Stack from '@mui/material/Stack';
import Chip from '@mui/material/Chip';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import { outlinedInputClasses } from '@mui/material';
import { getRequest, postRequest, putRequest } from "../../services/ApiServices";
import { useState, useEffect } from "react";
import { ToastError, ToastSuccess } from "../../services/ToastMsg";
import { propsToClassKey } from '@mui/styles';
import { FilterObj } from '../CommonComponents/globalfilterObj';
import { getCookie } from "../../services/Cookies";
import { Api } from '@mui/icons-material';
//import FilterContext from '../reports/FilterContext';

export default function CustomerName(props) {
    //var contextDate = React.useContext(userDetailContext)
    const { globalfilter,screen, updateParent, reset, type } = props;

    //const {filtercomObj, setfiltercomObj } = useContext(FilterContext);

    const [filteredString, setValue] = useState("");
    const [GlobalFilterSettingValue, setGlobalFilterSettingValue] = React.useState(localStorage.getItem('GlobalFilterSetting'));
    const [customerDetailsBySearch, setCustomerDetailsBySearch] = React.useState([]);
    const [selectedvalue, setselectedvalue] = React.useState([]);
    const [formObj, setFormObj] = useState(FilterObj);
    const autoTextCustomer = async (event) => {

        const searchStr = event.target.value;
        setValue(searchStr);
        try {
            const url = process.env.REACT_APP_CUSTOMER_PORTAL_API_URL + `Customer/${searchStr}`;
            const res = await getRequest(url);
            if (res?.status === 200) {
                // let newresult
                let data = res?.data || [];
                let result = data?.map((a, i) => {
                    return { id: a?.customerKey, name: a?.customerName };
                });
                if (selectedvalue) {
                    selectedvalue.forEach((val, i) => {
                        result = result.filter((ele) => ele.name != val.name)
                    })
                }
                //console.log('new', newresult)
                setCustomerDetailsBySearch(result);
                return;
            }
            //ToastError(res?.data?.message || 'Failed to fetch');
        } catch (err) {
            console.log('Failed to fetch customer keys', err);
            // ToastError(err?.response?.data?.message || 'Failed to fetch data');
        }

    }

    const handleChange = (event, newValue, type) => {


        props.onChange(newValue);
        const filteredCustomerKeys = {
            ...formObj,
            customerNameKey: newValue
        };
        setFormObj({ ...filteredCustomerKeys });
        setselectedvalue(newValue);
        setValue('');
        let selectedcustomer = newValue.map((i, v) => i.id).join(",");
        localStorage.setItem("currentpagecustomer", selectedcustomer);
        if (screen !== "GlobalFilter") {
            if (screen == 'reportsToT' || screen == 'assetsToT' || screen == 'trendsToT' || screen == 'schedulerToT' || screen == 'samplesToT') {
                let Obj = JSON.parse(localStorage.getItem('TOTFilterSetting'));
                Obj = {
                    ...Obj,
                    customerNameKey: newValue
                }
                localStorage.setItem("TOTFilterSetting", JSON.stringify(Obj));
            } else {
                let Obj = JSON.parse(localStorage.getItem('FilterSetting'));
                Obj = {
                    ...Obj,
                    customerNameKey: newValue
                }
                localStorage.setItem("FilterSetting", JSON.stringify(Obj));
            }
        }
        // let NewValue = customerDetailsBySearch.splice(newValue);
        // setCustomerDetailsBySearch(NewValue);


        // updateParent({ ...formObj,
        //     customerNameKey: newValue
        // })
    }
    React.useEffect(() => {
        //
        console.log(formObj)
    }, formObj)

    const defaultValue = (val) => {
        //
        let filtervalue = "";
        if (screen == 'reportsToT' || screen == 'assetsToT' || screen == 'trendsToT' || screen == 'schedulerToT' || screen == 'samplesToT') {
            filtervalue = JSON.parse(localStorage.getItem('TOTFilterSetting'));
        } else {
            filtervalue = JSON.parse(localStorage.getItem('FilterSetting'));
        }
        if (filtervalue !== "" && filtervalue !== undefined && filtervalue !== null && filtervalue !== "null" && screen !== "GlobalFilter") {
            const Obj = {
                ...formObj,
                customerNameKey: filtervalue.customerNameKey
            };
            setFormObj(Obj);
            setselectedvalue(filtervalue.customerNameKey);
        }
        else if (val !== "" && val !== undefined && val !== "null") {
            let Obj = JSON.parse(val);
            setFormObj(Obj);
            console.log('getcookievalue', formObj)
            setselectedvalue(Obj.customerNameKey);
        } else {
            setFormObj({});
        }
    }

    React.useEffect(() => {
        //
        if (reset>0)
            defaultValue(GlobalFilterSettingValue);

    }, [reset]);

    React.useEffect(() => {
        defaultValue(GlobalFilterSettingValue);

    }, []);
    return (
        <Stack spacing={3}>


            <Autocomplete
                multiple
                id="size-small-standard-multi"
                size="small"
                value={formObj?.customerNameKey || []}
                getOptionSelected={(option, value) => option.name === value.name}
                options={customerDetailsBySearch}
                getOptionLabel={(option) => option.name}
                inputProps={{
                    name: 'customer',
                    id: 'outlined-customer-native-simple',
                }}
                inputValue={filteredString}
                onChange={(event, newValue) => handleChange(event, newValue, type)}
                renderInput={(params) => (

                    <TextField
                        {...params}
                        variant="standard"
                        label="Customer Name"
                        placeholder=""
                        onChange={autoTextCustomer}

                    />
                )}

            />


        </Stack>
    );
}

// Top 100 films as rated by IMDb users. http://www.imdb.com/chart/top

// function one () {
//     let formobj = [{}];
//     function two () {
//         let formobj =[];


//     }

//     Api() {
//         formobj =[]
//     }
// }